import { Component, ElementRef, Inject } from '@angular/core';
import { RulevarService } from 'src/app/rule/rulevar.service';
import { FormArray,FormGroup,FormControl,UntypedFormArray,UntypedFormGroup } from '@angular/forms';
import { OnInit,AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { NgxCsvParser, NgxCSVParserError } from 'ngx-csv-parser';
import { RoutecrumpsService } from 'src/app/services/routecrumps.service';
import { Subject } from 'rxjs';
import { ViewChild } from '@angular/core';
import { TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { RuleService } from 'src/app/rule/rule-custom-service';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { FILE_PREVIEW_DIALOG_DATA } from 'src/app/log-search/cdk-overlay-injector';

@Component({
  selector: 'app-import-intel-list',
  templateUrl: './import-intel-list.component.html',
  styleUrls: ['./import-intel-list.component.scss']
})
export class ImportIntelListComponent {
  constructor(public rulevarservice: RulevarService,
    private router:Router,
    private ngxCsvParser: NgxCsvParser,
    private rcrumpService: RoutecrumpsService,
    public matdialog: MatDialog,
    public ruleService:RuleService,
    public toasterService:ToastService,
    private ref:MatDialogRef<ImportIntelListComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any){}

    rawData:any
    requiredHeaders:any
    importedFields=[]
    importErrorString=''
    routeBack:Subject<null> = new Subject();
    @ViewChild('Popup') Popup: TemplateRef<any>;
    @ViewChild('MaxRowPopup') MaxRowPopup: TemplateRef<any>;
    @ViewChild('confirmHeader') confirmHeader: TemplateRef<any>;
    dialogRef:any
    mat_spinner_create_state:boolean = false;
    @ViewChild('uploadFile') uploadFile!: ElementRef<HTMLElement>;
    inputShow=false
    filename:string
    // @Inject(FILE_PREVIEW_DIALOG_DATA) public data

  ngOnInit(){
    // this.createRouteCrumps()
//console.log(this.data)
    if(this.data == "import"){
      this.inputShow=true
      // console.log(this.ref)
    }
//console.log("List Details ---->",this.rulevarservice.importDetail)
    
    this.entryMode.setValue(this.data)
   
    this.manualTable.push(this.rulevarservice.addNewManual())
//console.log(this.manualTable)
    this.setImportTable()
//console.log(this.rulevarservice.importTable)
//console.log(this.createTable)
  }
  ngAfterViewInit(){
    if(this.data === 'import'){
      // console.log("click")
      this.uploadFile.nativeElement.click()
    }
  }

  openUpload(event){
    // console.log("uploadClick")
  }
  setImportTable(){ // create structure for import
    Object.keys(this.rulevarservice.importTable).forEach(key=>{
      
      if(parseInt(key) !=0){
//console.log({key})
        this.addClick(parseInt(key))
      }
    })
    this.table.patchValue(this.rulevarservice.importTable)

  }
  addClick(i){ // add columns to form control
    if(this.table.controls.length < this.rulevarservice.intelColumnLimit){
      this.table.insert(i+1,this.rulevarservice.addNewTable())
    }
  }

  removeAllManualClick(i){ // remove All manual entry rows
    this.manualTable.removeAt(i)
  }
  resetTable(){ //reset create table
    for(let i=this.table.controls.length-1;i>=0;i--){
      this.removeClick(i)
    }
  }
  resetManualTable(){ // reset manual entry table
    for(let i=this.manualTable.controls.length-1;i>=0;i--){
      this.removeAllManualClick(i)
    }
  }

  resetAll(){
    const reset=this.rulevarservice.jsonEdit(this.rulevarservice.defaultIntel)
    this.rulevarservice.intelForm.patchValue(reset)
    this.entryMode.reset()
    this.resetTable()
    this.resetManualTable()
  }
  removeClick(index:number){
    if(this.table.length>1){
      if (this.manualTable.controls.length > 0) { // Dynamically Remove formcontrol
        Object.keys(this.manualTable.controls).forEach(key => {
          const fg = this.manualTable.get(key.toString()) as FormGroup;
          const fieldName = this.table.get((index).toString()).get('fieldName')?.value;
          fg.removeControl(fieldName);
        });
      }
      this.table.removeAt(index)
    }
    
  }

  get createTable(){
    return this.rulevarservice.intelForm.get('createTable') as UntypedFormGroup
  }

  get table(){
    return this.createTable.get('table') as UntypedFormArray
  }
  get entryMode(){
    return this.createTable.get('entryMode')
  }
  get manualTable(){
    return this.rulevarservice.manualIntel.get('manualTable') as UntypedFormArray
   }

   addManualClick(i, mode='default'){ // add rows in manual mode
    // console.log(this.rulevarservice.importDetail.total_rows+this.manualTable.value.length)
    // console.log(this.rulevarservice.importDetail.max_entry)
    if(mode === 'keydown'){
//console.log(mode ,"->",i,this.manualTable.length)
      if(i === this.manualTable.controls.length-1){
        if(this.rulevarservice.importDetail.total_rows+this.manualTable.value.length >=this.rulevarservice.importDetail.max_entry){
          this.rulevarservice.manualIntelError=true
          this.rulevarservice.manualErrorString="Max limit reached"
        }else{
          this.rulevarservice.manualIntelError=false
          this.rulevarservice.manualErrorString="*Fields can't be empty"
          this.manualTable.insert(i+1,this.rulevarservice.addNewManual())
        }
      }
    }else{
//console.log(mode ,"->",i,this.manualTable.length)
      if(this.rulevarservice.importDetail.total_rows+this.manualTable.value.length >=this.rulevarservice.importDetail.max_entry){
        this.rulevarservice.manualIntelError=true
        this.rulevarservice.manualErrorString="Max limit reached"
      }else{
        this.rulevarservice.manualIntelError=false
        this.rulevarservice.manualErrorString="*Fields can't be empty"
        this.manualTable.insert(i+1,this.rulevarservice.addNewManual())
      }
    }
   
  }
  removeManualClick(i){ // remove manual entry rows
    if(this.manualTable.length>1){
      this.manualTable.removeAt(i)
    }else{
      if(this.manualTable.length === 1){
        Object.keys(this.manualTable.get('0').value).forEach(data=>{
          // console.log(this.manualTable.get('0').get(data))
          this.manualTable.get('0').get(data).setValue('')
        })
      }
    }
  
  }
  checkImporedFields(){
    const names = this.table.value.map(item => item.mappedField?.trim().toLowerCase());

    return new Set(names).size !== names.length;
  }
  async postIntelList(){ //Post Intel List
    let postvalue={}
    let importfile=[]
    let importRows=[]
    let importCols=[]
    
    if(this.entryMode.value ==="import"){
      importCols.push("list_id")
      Object.keys(this.rulevarservice.postFile).forEach(val=>{
        let obj={}
        Object.keys(this.table.value).forEach(key=>{
          obj[this.table.value[key].fieldName]=this.rulevarservice.postFile[val][this.table.value[key].mappedField]
        })
        importfile.push(obj)
      })
      // console.log({importfile})

      Object.keys(importfile[0]).forEach(key=>{
        importCols.push(key)
      })

      Object.keys(importfile).forEach(key=>{
        let row =[]
        row.push(this.rulevarservice.importDetail.list_id)
        Object.keys(importfile[key]).forEach(data=>{
          row.push(importfile[key][data])
        })
        importRows.push(row)
      })

    }
    postvalue['entryMode']=this.entryMode.value
    if(this.entryMode.value=== "import"){
      // postvalue['rows']=importfile
      postvalue['rows']=importRows
      postvalue['cols']=importCols
    }else{
      postvalue['cols'] = this.rulevarservice.postFileCols
      postvalue['rows'] = this.rulevarservice.postFile
    }
    postvalue['list_id']=this.rulevarservice.importDetail.list_id
    postvalue['list_name']=this.rulevarservice.importDetail.list_name
    
//consoe.log("Cols =---->", this.rulevarservice.postFileCols)
//consoe.log("file =---->",this.rulevarservice.postFile)
//consoe.log("PostValue -->",postvalue)
    await this.ruleService.postIntelListImport.postrequest(postvalue)
    .then((dat: any) => {
      this.mat_spinner_create_state = false;
      if (dat) {
        this.open_toaster('Imported to intel list', 'success');
        this.rulevarservice.postFileCols=[]
        this.rulevarservice.postFile=[]
        this.ruleService.providerulelist.emitstate = -1;
      }else{
        this.open_toaster('Cannot import to intel list', 'failure')
        this.rulevarservice.postFileCols=[]
        this.rulevarservice.postFile=[]
      }
      this.previousClick()
    })
    .catch(err => {
      this.mat_spinner_create_state = false;
      this.open_toaster('Cannot import to intel list', 'failure')
      this.rulevarservice.postFileCols=[]
      this.rulevarservice.postFile=[]
    })
// console.log("<---------- INTEL LIST POSTED ---------->")
//console.log("<---------- INTEL LIST POSTED ---------->")
    this.router.navigateByUrl("intel-list");
  }

  open_toaster(msg: string, type: any) {
    this.toasterService.show({
      text: msg,
      type: type
    })
  }

  createRouteCrumps(){
    this.rcrumpService.route_crumps[2] = {
      disp_str:'Import Intel List',
      routeTo:"intel-list/import-intel-list",
      callback:this.routeBack,
      isParent:false
    }
  }
  previousClick(){
    // this.router.navigateByUrl("intel-list");
    this.ref.close()
  }
  nextClick(){
    // console.log(this.manualTable.value)
    // console.log(this.createTable.value)
      if(this.entryMode.value === "import"){

        // if(this.table.valid){
          if(this.rulevarservice.dataTypeError.length === 0){
            if(!this.checkImporedFields()){
//console.log(this.rulevarservice.importDetail.total_rows+this.rulevarservice.postFile.length)
//console.log(this.rulevarservice.importDetail.max_entry)
              if(this.rulevarservice.importDetail.max_entry<(this.rulevarservice.importDetail.total_rows+this.rulevarservice.postFile.length)){
                this.openMaxRowPopup()
              }else{
              this.postIntelList()
              this.rulevarservice.importIntelError=false
              }
            }
            else{
              this.rulevarservice.importIntelError=true
              this.importErrorString=this.rulevarservice.importErrorString[101]
//console.log("-----Duplicates-----")
            }
          }
        // }
        // else{
        //   this.rulevarservice.importIntelError=true
        //   this.importErrorString=this.rulevarservice.importErrorString[102]
//console.log("-----Empty-----")
        // }
      }
      else{
        if(this.rulevarservice.manualIntel.valid){
          let rawValue=this.manualTable.getRawValue()
          this.rulevarservice.postFileCols=[]
          this.rulevarservice.postFileCols.push("list_id")
          Object.keys(rawValue[0]).forEach(key=>{
            this.rulevarservice.postFileCols.push(key)
          })
          Object.keys(rawValue).forEach(key=>{
            let row =[]
            row.push(this.rulevarservice.importDetail.list_id)
            Object.keys(rawValue[key]).forEach(data=>{
              row.push(rawValue[key][data])
            })
            this.rulevarservice.postFile.push(row)
          })
//console.log(this.rulevarservice.postFileCols)
//console.log(this.rulevarservice.postFile)
//console.log("Manual Table-->",this.manualTable.getRawValue())
          // this.rulevarservice.postFile=this.manualTable.getRawValue()
          this.rulevarservice.manualIntelError=false
          this.postIntelList()
        }
        else{
          this.rulevarservice.manualIntelError=true
          this.rulevarservice.manualErrorString="*Fields can't be empty"
        }
      }
  }
  openPopup() {
    const dialogRef: MatDialogRef<any> = this.matdialog.open(this.Popup, {
      width: '35vw',  
      height: '15vh'     
    });
    this.dialogRef=dialogRef
  }

  popupYes(){
    this.uploadFile.nativeElement.click()
    this.dialogRef.close()
  }

  openConfirmHeader(){
    const dialogRef: MatDialogRef<any> = this.matdialog.open(this.confirmHeader, {
      width: '35vw',  
      height: '15vh'     
    });
    this.dialogRef=dialogRef
  }

  openMaxRowPopup() {
    const dialogRef: MatDialogRef<any> = this.matdialog.open(this.MaxRowPopup, {
      width: '35vw',  
      height: '15vh'     
    });
    this.dialogRef=dialogRef
  }

  MaxRowPopupYes(){
    this.rulevarservice.postFile.splice(this.rulevarservice.importDetail.max_entry-this.rulevarservice.importDetail.total_rows,this.rulevarservice.postFile.length-(this.rulevarservice.importDetail.max_entry-this.rulevarservice.importDetail.total_rows))
    this.dialogRef.close()
    this.nextClick()
  }
  MaxRowPopupNo(){
    this.dialogRef.close()
  }

  openFileDialog(evt) {
    window.addEventListener(
      'focus',
      () => this.onFileChange(evt),
      { once: true }
    );
  }

  onFileChange(evt: any) { // Read uploaded file

    // console.log("OnFileChange")
    Object.keys(this.rulevarservice.importTable).forEach(key=>{
      this.rulevarservice.importTable[key].mappedField=''
    })
    const input = evt.target as HTMLInputElement;
    setTimeout(() => {
//console.log({input})
                                          
    
      if({input}.input.files.length === 0){
        // console.log("if")
        this.ref.close()
      }
      else{
        // console.log("else")
        this.filename={input}.input.files[0].name
        const target: DataTransfer = <DataTransfer>(evt.target);
//console.log(target.files[0].size)
        if(target.files[0].size > this.rulevarservice.importSizeLimit){
          this.openPopup()
          input.value=""
        }
        else{
          const extension = target.files[0].name.split(".").pop().toLowerCase();
//console.log({extension})
          if (target.files.length !== 1) {
//console.log('Please upload a single Excel file.');
            return;
          }
          
          if(extension != "csv"){ // if XLSX
            // this.openConfirmHeader()
            // console.log("after popup")
            const reader: FileReader = new FileReader();
            reader.onload = (e: any) => {
//console.log({e})
              const binaryStr = e.target.result;
              const workbook = XLSX.read(binaryStr, { type: 'binary' });
              const sheetName = workbook.SheetNames[0];
              const sheet = workbook.Sheets[sheetName];
//console.group('Binary')
      // console.log({binaryStr})
// console.log({workbook})
//console.log({sheetName})
      // console.log({sheet})
              const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });

              // console.log(jsonData)

              this.rawData = jsonData;
              this.rulevarservice.postFile=[]
              this.rulevarservice.postFile=jsonData
      // console.log(this.rawData);
              this.rulevarservice.allFields=[]
              this.rulevarservice.importedFields=[]
              // let header=[]
              // Object.keys(this.rawData[0]).forEach((row:any,i:number)=>{
              //   header.push('Column '+(i+1).toString())
              // })
              // console.log({header})
              // this.rulevarservice.importedFields=header
              // this.rulevarservice.allFields=header
              this.rulevarservice.importedFields=this.getHeaders(this.rawData[0])
              this.rulevarservice.allFields=this.getHeaders(this.rawData[0])
//console.log(this.rulevarservice.importedFields)
              const columnTypes = this.getColumnTypes(sheet);
              this.rulevarservice.importColumType={}
              this.rulevarservice.importColumType=this.getColumnTypes(sheet)
//console.log('Column Types:', columnTypes);
              const updatedData = this.rawData.map((row, index) => ({
                '#': index + 1,   // add serial number (1-based)
                ...row            // spread original row
              }));

              this.rawData = updatedData;
              
              // this.errors = this.validateHeaders(jsonData);

              // if (this.errors.length === 0) {
              //   this.parsedData = this.mapToModel(jsonData);
              // } else {
              //   this.parsedData = [];
              // }
              // this.parsedData = jsonData
            };
            reader.readAsBinaryString(target.files[0]);
            
          }
          else{ // IF CSV
                const files = evt.srcElement.files;

              this.ngxCsvParser.parse(files[0], {
                header: true,          // use first row as headers
                delimiter: ',',        // CSV delimiter
                encoding: 'utf8'
              }).pipe().subscribe({
                next: (result: Array<any>) => {
//console.log('Parsed result:', result);
                  let csvRecords = result;
                  this.rulevarservice.postFile=[]
                  this.rulevarservice.postFile=result
                  this.rawData=result
                  let columnDataTypes = this.detectColumnDataTypes(result);
                  this.rulevarservice.importColumType={}
                  this.rulevarservice.importColumType = columnDataTypes

//console.log('Detected column types:', columnDataTypes);
                  this.rulevarservice.importedFields=[]
                  this.rulevarservice.importedFields=Object.keys(result[0]);
                const updatedData = result.map((row, index) => ({
                  '#': index + 1,   // add serial number (1-based)
                  ...row            // spread original row
                }));

                this.rawData = updatedData;

                // this.rulevarservice.importedFields = ['#', ...Object.keys(result[0])];

//console.log('Headers:', this.rulevarservice.importedFields);
//console.log('Updated Data:', this.rawData);
                },
                error: (error: NgxCSVParserError) => {
//console.error('Error parsing CSV:', error);
                }
              });
            
          }
          this.inputShow=false
        }
        // console.log(this.rawData);
      }
    }, 500); 
  }
   detectColumnDataTypes(records: any[]): { [key: string]: string } {
    if (!records || records.length === 0) return {};

    const sampleSize = Math.min(10, records.length); // use first 10 rows
    const sample = records.slice(0, sampleSize);
    const types: { [key: string]: string } = {};

    Object.keys(records[0]).forEach((col) => {
      const values = sample
        .map(r => r[col])
        .filter(v => v !== undefined && v !== null && v !== '');

      types[col] = this.inferType(values);
    });

    return types;
  }

  
  inferType(values: any[]): string {
    if (!values.length) return 'text';

    const isNumber = values.every(v => !isNaN(v) && v.trim() !== '');
    if (isNumber) return 'number';

    const isBoolean = values.every(v =>
      ['true', 'false', '1', '0'].includes(v.toString().toLowerCase())
    );
    if (isBoolean) return 'boolean';

    const looksLikeDate = (v: string) =>
    /^\d{4}-\d{2}-\d{2}$/.test(v) || /^\d{2}\/\d{2}\/\d{4}$/.test(v);

    const allDate = values.every(v => looksLikeDate(v) && !isNaN(Date.parse(v)));
    if (allDate) return 'date';

    return 'text';
  }
  
 
  getColumnTypes(sheet: XLSX.WorkSheet): Record<string, string> {
    const range = XLSX.utils.decode_range(sheet['!ref']!);
    const columnTypes: Record<string, string> = {};
  
    // Extract header names from the first row
    const headerRow = range.s.r; // usually row 0
    const headers: Record<number, string> = {};
  
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = { c: C, r: headerRow };
      const cellRef = XLSX.utils.encode_cell(cellAddress);
      const cell = sheet[cellRef];
      const headerName = cell ? String(cell.v).trim() : `Column${C + 1}`;
      headers[C] = headerName || `Column${C + 1}`;
    }
  
    // Loop through columns
    for (let C = range.s.c; C <= range.e.c; ++C) {
      let types: Set<string> = new Set();
  
      for (let R = range.s.r + 1; R <= range.e.r; ++R) { // Skip header row
        const cellAddress = { c: C, r: R };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        const cell = sheet[cellRef];
  
        if (cell && cell.t) {
          types.add(cell.t); // 's' = string, 'n' = number, 'b' = boolean, etc.
        }
      }
  
      // Determine dominant type
      const typeArray = Array.from(types);
      let type = 'unknown';
      if (typeArray.length === 1) type = typeArray[0];
      else if (typeArray.includes('s')) type = 's';
      else if (typeArray.includes('n')) type = 'n';
  
      // Convert to readable label
      const readable = {
        s: 'text',
        n: 'number',
        b: 'boolean',
        d: 'date',
        e: 'error',
        unknown: 'unknown'
      };
  
      const headerName = headers[C];
      columnTypes[headerName] = readable[type as keyof typeof readable];
    }
  
    return columnTypes;
  }
  

  validateHeaders(data: any[]): string[] {
    const fileHeaders = Object.keys(data[0] || {});
    const missing = this.requiredHeaders.filter(h => !fileHeaders.includes(h));
    return missing.length > 0 ? [`Missing headers: ${missing.join(', ')}`] : [];
  }

  mapToModel(data: any[]) {
    // return data.map(row => ({
    //   Service: row['service'],
    //   Count: Number(row['count']),
    // }));
    return data
  }

  getHeaders(rawData:{}){
    // console.log({rawData})
    let header=[]
    Object.keys(rawData).forEach(key=>{
     header.push(key)
    })
    return header
  }

  ngOnDestroy(){
    this.resetAll()
    this.rulevarservice.manualIntelError=false
    this.rulevarservice.manualErrorString="*Fields can't be empty"
    this.rulevarservice.importDetail=null
    this.rulevarservice.createShowError=false
    this.rulevarservice.importIntelError=false
    this.rulevarservice.manualIntelError=false
    this.rulevarservice.intelEditMode=false
    this.rulevarservice.contextValid=true
    this.rulevarservice.resetContextErrors()
    this.rulevarservice.isIntel=false
    this.rulevarservice.ruleLandingchangeTab(2)
  }
}
